import { AboutCompanyPage, PageHead, SeoFooter } from '@/components'

const About = ({ data }) => {
    return (
        <>
            <PageHead meta={data.seo_meta}/>
            <AboutCompanyPage data={data} />
            {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
        </>
    )
}

About.options = {
    header: 'dark',
    footer: 'dark',
}

About.getInitialProps = async ({ api }) => {
    const { data } = await api.pageWithSlug('about')()
    data.reviews = await api.reviews() ?? []
    return { data: data }
}

export default About
